import { Phone, FileText } from "lucide-react";
import { PHONE_TEL } from "../lib/content";

export const MobileStickyCTA = () => {
  const goQuote = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-navy/10 bg-white/90 p-3 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <a
        href={`tel:${PHONE_TEL}`}
        data-testid="sticky-call-btn"
        className="flex items-center justify-center gap-2 rounded-full border border-navy py-3.5 text-sm font-bold text-navy"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <button
        onClick={goQuote}
        data-testid="sticky-quote-btn"
        className="flex items-center justify-center gap-2 rounded-full bg-gold py-3.5 text-sm font-bold text-navy"
      >
        <FileText className="h-4 w-4" /> Request Quote
      </button>
    </div>
  );
};
